import { CartCoupon } from "../cartCoupon";
import { formatMoney } from "../../functions/money";
import {useCartAmounts} from "../../hooks/useCartAmounts";
import { useSelector } from "react-redux";
import { MakeOrderButton } from "../../components/makeOrderButton";

export const CartResumeContent = ({
  canMakeOrder = true,
  showCoupon = true,
  localized = false,
  quote,
  showDetails = true,
  showOrderTotals = true,
  actionText,
  actionUrl,
  actionBackText = null,
  actionBackUrl = null,
}) => {
  const cart = useSelector((state) => state.aplicationConfig.userConfig.cart);

  const {amounts, busy, error, retry} = quote;
  const getTotalQuantity = () => (cart?.ShoppingCartProducts || []).reduce((sum, line) => sum + Number(line.quantity), 0);
  const money = (value) => amounts ? (localized ? formatMoney(Number(value)) : Number(value).toFixed(2) + " €") : "—";

  return (
    <div className="order-commander-totals">
      {showCoupon && <CartCoupon />}
      {busy && <p role="status">Calculando el importe…</p>}
      {error && <div role="alert">No se pudo calcular el importe. <button type="button" onClick={retry}>Reintentar</button></div>}
      {showDetails && (
        <div className="order-commander-totals-container">
          <div className="order-commander-totals-row">
            <div className="order-commander-total-row-label">Subtotal sin IVA</div>
            <div className="order-commander-total-row-info">{getTotalQuantity()} artículos</div>
            <div className="order-commander-total-row-value">{money(amounts?.subtotal)}</div>
          </div>
          <div className="order-commander-totals-row">
            <div className="order-commander-total-row-label">{localized ? "Gastos de envío" : "Entrega"}</div>
            <div className="order-commander-total-row-info"> </div>
            <div className="order-commander-total-row-value">{money(amounts?.shipping)}</div>
          </div>
          <div className="order-commander-totals-row">
            <div className="order-commander-total-row-label">Descuento</div>
            <div className="order-commander-total-row-info"> </div>
            <div className="order-commander-total-row-value">{money(amounts?.discounts)}</div>
          </div>
          <div className="order-commander-totals-row">
            <div className="order-commander-total-row-label">Impuestos</div>
            <div className="order-commander-total-row-info"> IVA</div>
            <div className="order-commander-total-row-value">{money(amounts?.tax)}</div>
          </div>
        </div>
      )}
      {showOrderTotals && (
        <div className="order-commander-totals-resume">
          <div className="order-commander-totals-resume-label">{showDetails ? "Total" : getTotalQuantity() + " artículos"}</div>
          <div className="order-commander-totals-resume-value">{money(amounts?.total)}</div>
        </div>
      )}
      {canMakeOrder && (
        <MakeOrderButton disabled={busy || error || !amounts || (cart.ShoppingCartProducts||[]).some(line=>line.unavailable)} actionText={actionText} actionUrl={actionUrl} actionBackText={actionBackText} actionBackUrl={actionBackUrl} />
      )}
    </div>
  );
};

export const CartResume = props => {
  const quote = useCartAmounts();
  return <CartResumeContent {...props} quote={quote} />;
};
